<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <radialGradient id="gradient">
            <stop offset="80%" stop-color="rgba(255, 255, 255, 0)"/>
            <stop offset="90%" stop-color="rgba(255, 255, 255, .5)"/>
        </radialGradient>
    </defs>
    <circle cx="250" cy="250" r="250" fill="url(#gradient)"/>
    <circle cx="250" cy="250" r="245" fill="none" stroke="rgba(255, 255, 255, 0.8)" stroke-width="10"/>
    <g fill="#222">
        <rect x="1" y="248" width="18" height="4"/>
        <rect x="481" y="248" width="18" height="4"/>
        <rect x="248" y="1" width="4" height="18"/>
        <rect x="248" y="481" width="4" height="18"/>
    </g>
</svg>